import './App.css';
import './css/all.min.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Nav from './components/Include/nav';
import SideBar from './components/Include/SideBar';
import Footer from './components/Include/Footer';

import ProductList from './components/OwnerDashboard/ProductList';
import AddProduct from './components/OwnerDashboard/AddProduct';
import CreateProject from './components/OwnerDashboard/CreateProject';
import UpdateProduct from './components/OwnerDashboard/UpdateProduct';

import PrivacyPolicy from './components/PrivacyPolicy';
import Signup from './components/Signup';
import Login from './components/Login';
import VerifyEmail from './components/VerifyEmail';

import UpdateProfile from './components/OwnerDashboard/UpdateProfile';
import MarkAttendance from './components/EmployeeDashboard/MarkAttendance';
import TrackingEmployee from './components/EmployeeDashboard/TrackingEmployee';
import Dashboard from './components/OwnerDashboard/Dashboard';
import AddEmployee from './components/OwnerDashboard/AddEmployee';
import EmployeesList from './components/OwnerDashboard/Employees';
import UpdateEmployee from './components/OwnerDashboard/UpdateEmployee';
import UploadPayroll from './components/OwnerDashboard/Payroll';

import EmployeeRecord from './components/OwnerDashboard/EmployeeRecord';


import EmpRecord from './components/EmployeeDashboard/EmpRecord';
import PrivateComponent from './components/Include/PrivateComponent';
import EmpPrivateComponent from './components/Include/EmpPrivateComponent';

import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
 import React, {useState} from "react";


function App() {

   const [auth, setAuth] = useState(() => {

    const employee = localStorage.getItem("empuser");
    const owner = localStorage.getItem("user");

    if (employee) {
        return {
            type: "employee",
            user: JSON.parse(employee)
        };
    }

    if (owner) {
        return {
            type: "owner",
            user: JSON.parse(owner)
        };
    }

    return null;
});

const handleLogout = () => {
    localStorage.clear();
    setAuth(null);
};


  return (
    <div className="App">
       
      <BrowserRouter>
      {auth?.type !== "owner" && <Nav onLogout={handleLogout} />}

    <div className={auth?.type === "owner" ? "d-flex" : "backcover"}>
     {auth?.type === "owner" && <SideBar onLogout={handleLogout} />}
      <Routes>
        <Route path='/' element={<HomePage/>}/>

      <Route element={<PrivateComponent/>}>
        <Route path='/productlist' element={<ProductList/>}/>
        <Route path='/add' element={<AddProduct/>}/>
        <Route path='update-profile' element={<UpdateProfile/>} />
        <Route path='/create-project' element={<CreateProject/>}/>
        <Route path='/update/:id' element={<UpdateProduct/>}/>
        <Route path='/update-employee/:id' element={<UpdateEmployee/>}/>
        <Route path='/add-employee' element={<AddEmployee/>}/>
        <Route path='/dashboard' element={<Dashboard/>}/>
        <Route path='/employees' element={<EmployeesList/>}/>
        <Route path='/payroll' element={<UploadPayroll/>}  />
        <Route path='/employee-record/:empid' element={<EmployeeRecord/>}/>
        <Route path='/profile' element={<h1>Profile Comp.</h1>}/>
        <Route path='/logout' element={<h1>Logout Comp.</h1>}/>
      </Route>
        
       

        <Route element={<EmpPrivateComponent/>}>
        <Route path='/my-record' element={<EmpRecord/>}/>
        <Route path='/time-tracker' element={<TrackingEmployee/>}/>
        </Route>

        <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
        <Route path='/signup' element={<Signup/>}/>
        <Route path='/login' element={<Login setAuth={setAuth}/>}/>
        <Route path='/verify-email' element={<VerifyEmail/>}/>
        <Route path='/mark-attendance' element={<MarkAttendance/>}/>

      </Routes>

    </div>

    <Footer/>
      </BrowserRouter>
     
    </div>
  );
}

export default App;
